import { FC } from "preact/compat";
import HourglassIcon from "@material-design-icons/svg/outlined/hourglass_empty.svg";

const Preview: FC = () => (
    <div className="size-full flex flex-col justify-center gap-y-2 text-xs px-4 py-2">
        {[30, 22, 36].map((width, idx) => (
            <div
                key={idx}
                className="h-5 flex items-center justify-between px-2 w-full bg-gradient-to-r from-zinc-100 to-zinc-300 rounded-2xl border border-gray-200"
            >
                <div style={{ width }} className="bg-zinc-300 h-1.5" />
                <HourglassIcon
                    width="16"
                    height="16"
                    className="fill-gray-400"
                />
            </div>
        ))}
    </div>
);

export default Preview;
